import { Deserialize, IJsonObject, Serialize } from 'dcerialize';
import { Injectable, inject } from '@angular/core';
import { Announcement } from '../models/announcement';
import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AnnouncementService {
  private http = inject(HttpClient);
  private apiService = inject(ApiService);


  get path(): string {
    return this.apiService.getApiUrl() + 'announcement';
  }

  /**
   * Create announcement method
   */
  createAnnouncement(announcement: Announcement): Observable<Announcement> {
    return this.http.post<IJsonObject>(
      `${this.path}`,
      Serialize(announcement, () => Announcement)
    ).pipe(
      map((announcement) => Deserialize(announcement, () => Announcement))

    );
  }

  /**
   * Get current active announcement
   */
  getCurrentActiveAnnouncement(): Observable<Announcement | undefined> {
    return this.http.get<IJsonObject>(`${this.path}/current`).pipe(
      map((announcement) =>
        announcement && Object.keys(announcement).length > 1
          ? Deserialize(announcement, () => Announcement)
          : undefined
      )
    );
  }

  /**
   * Update current active announcement
   */
  updateCurrentActiveAnnouncement(announcement: Announcement): Observable<Announcement> {
    return this.http.patch<IJsonObject>(
      `${this.path}/current`,
      Serialize(announcement, () => Announcement)
    ).pipe(
      map((announcement) => Deserialize(announcement, () => Announcement)));
  }

  /**
   * Disable current active announcement by setting its end date as now
   */
  disableCurrentActiveAnnouncement(): Observable<void> {
    return this.http.delete<void>(`${this.path}/current`);
  }
}

